// import { latexParser } from "latex-utensils";

// // export function FileParser(files) {
// //     if (!files?.data || !Array.isArray(files.data)) return [];

// //     const results = [];
// //     // structure: [{ fileName, fileId, cites: [] }]

// //     files.data.forEach(file => {
// //         if (!file.content) return;

// //         let ast;
// //         try {
// //             ast = latexParser.parse(file.content);
// //         } catch (e) {
// //             console.error(`Parse error in ${file.name}`, e);
// //             return;
// //         }

// //         const cites = new Set();

// //         function walk(nodes) {
// //             if (!Array.isArray(nodes)) return;

// //             for (const node of nodes) {
// //                 // Detect \cite
// //                 if (node.kind === "command" && node.name === "cite") {
// //                     const arg = node.args?.[0];
// //                     if (arg?.kind === "arg.group") {
// //                         const text = arg.content
// //                             .filter(n => n.kind === "text.string")
// //                             .map(n => n.content)
// //                             .join("");

// //                         text.split(",").forEach(key => {
// //                             if (key.trim()) cites.add(key.trim());
// //                         });
// //                     }
// //                 }

// //                 // Recursion
// //                 if (node.content) walk(node.content);
// //                 if (node.args) {
// //                     node.args.forEach(a => a.content && walk(a.content));
// //                 }
// //             }
// //         }

// //         walk(ast);

// //         if (cites.size > 0) {
// //             results.push({
// //                 fileName: file.name,
// //                 fileId: file.file_uuid,
// //                 cites: Array.from(cites)
// //             });
// //         }
// //     });

// //     return results;
// // }
// export function FileParser(files,ace) {
//     if (!files?.data) return [];
//     console.log("it is starting to perform")
//     const results = [];

//     const citeRegex = /\\cite\s*\{([^}]+)\}/g;

//     files.data.forEach(file => {
//         if (!file.content) return;

//         const cites = new Set();
//         let match;

//         while ((match = citeRegex.exec(file.content)) !== null) {
//             const citeContent = match[1]; // inside { }

//             // Handle multiple citations: \cite{a,b,c}
//             citeContent.split(",").forEach(key => {
//                 const trimmed = key.trim();
//                 if (trimmed) {
//                     cites.add(trimmed);
//                 }
//             });
//         }
//         console.log("the file name is :", file.name, "the file id is :", file.file_uuid)
//         if (cites.size > 0) {
//             results.push({
//                 fileName: file.name,
//                 fileId: file.file_uuid,
//                 cites: Array.from(cites)
//             });
//         }

//     });
//     const fileexist = files.data.some((item) => { return item.name === "Reference.tex" });
//     if(fileexist){
//         const referencefile=files.find((item)=>{return item.name === "Reference.tex"});
//         let newSet=new Set();
//         const citeRegex = /\\bibitem\s*\{([^}]+)\}/g;
//         let matches=citeRegex.exec(referencefile.content);
//         const citeContent=matches[1];




//     }
//     return results;
// }


export function FileParser(files, ace) {
    if (!files?.data) return [];

    console.log("Starting to parse files for citations");

    const citationResults = [];
    const allCitations = new Set(); // Track all citations used across files

    const citeRegex = /\\cite\s*\{([^}]+)\}/g;

    // Step 1: Collect all citations from all files
    files.data.forEach(file => {
        if (!file?.content || typeof file.content !== 'string') return;

        const fileCites = new Set();
        let match;

        // Reset regex
        citeRegex.lastIndex = 0;

        while ((match = citeRegex.exec(file.content)) !== null) {
            const citeContent = match[1]; // inside { }

            // Handle multiple citations: \cite{a,b,c}
            citeContent.split(",").forEach(key => {
                const trimmed = key.trim();
                if (trimmed) {
                    fileCites.add(trimmed);
                    allCitations.add(trimmed); // Add to global citations set
                }
            });
        }

        console.log("File:", file.name, "Citations found:", fileCites.size);

        if (fileCites.size > 0) {
            citationResults.push({
                fileName: file.name,
                fileId: file.file_uuid,
                cites: Array.from(fileCites)
            });
        }
    });

    // Step 2: Find Reference.tex file
    const referenceFile = files.data.find((item) => item.name === "Reference.tex");

    if (!referenceFile) {
        console.log("No Reference.tex file found");
        return {
            citationResults,
            allCitations: Array.from(allCitations),
            unusedReferences: [],
            message: "No Reference.tex file found"
        };
    }

    console.log("Reference.tex file found");

    // Step 3: Extract all \bibitem entries from Reference.tex
    const allBibitems = new Set();
    const bibitemRegex = /\\bibitem\s*\{([^}]+)\}/g;
    let bibMatch;

    // Reset regex
    bibitemRegex.lastIndex = 0;

    while ((bibMatch = bibitemRegex.exec(referenceFile.content)) !== null) {
        const bibitemKey = bibMatch[1].trim();
        if (bibitemKey) {
            allBibitems.add(bibitemKey);
        }
    }

    console.log("Total bibitems found:", allBibitems.size);
    console.log("Total citations used:", allCitations.size);

    // Step 4: Find unused references (bibitems not cited anywhere)
    const unusedReferences = Array.from(allBibitems).filter(
        bibitem => !allCitations.has(bibitem)
    );

    console.log("Unused references:", unusedReferences);

    // Step 5: Return comprehensive results
    return {
        citationResults,           // Citations grouped by file
        allCitations: Array.from(allCitations),  // All unique citations used
        allBibitems: Array.from(allBibitems),    // All bibitems in Reference.tex
        unusedReferences,          // Bibitems that are NOT cited anywhere
        unusedCount: unusedReferences.length,
        totalBibitems: allBibitems.size,
        totalCitations: allCitations.size
    };
}
